import API from '../../../services/API';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { TICKET_MANAGEMENT_TYPES, TICKET_FILE_TYPES } from '../../../constants/actionTypes/ticketActionTypes';
import { progressActionTypes } from '../../../constants/actionTypes/commonActionTypes';

import axios from 'axios';

const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': 'window.EMAIL',
        'csrftoken': window.csrf_token
    }
});

const successStatusCode = 200;

export const addTicket = ticketData => ({
    type: TICKET_MANAGEMENT_TYPES.UPDATE_TICKET,
    ticketData
});

export const isLoading = (value) => {
    return {
        type: value
    };
};

export const isLoaded = (value, data) => {
    return {
        type: value,
        payload:data
    };
};

export const isError = (value, error) => {
    return {
        type: value,
        payload:error
    };
};
/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const getTickets = (url) => async (dispatch, getState) => {
    const data = await API.getData(url, dispatch, actions, true, getState());

    if (data.ticketListJson) {
        return ( data.ticketListJson.filter(obj => obj.number !== undefined) );
    }
};


export const getTicketTypes = (url) => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        return data;
    } else {
        console.error('Cannot getTickets', url);
    }

};

export const getTicketDetail = (url) => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        return data;
    }
};

/************************

 # POST calls

 ************************/



export const createTicket = (...args) => async dispatch => {
    const [url, body, isFileUploadAllowed ] = args;
    const params = isFileUploadAllowed ? [ url, body, 'POST', false, undefined, 'multipart/form-data' ] : [ url, body, undefined, false ];
    const data = await API.postData(params, dispatch, actions);
    if (data) {
        return data;
    } else {
        console.error('Cannot createTickets', url);
    }
};

export const getComments = (...args) => async dispatch => {
    const [url] = args;
    const params = [ url];
    const data = await API.getData(params, dispatch, actions);
    if (data) {
        dispatch(addTicket(data));
        return data;
    } else {
        console.error('Cannot getComments', url);
    }

};

export const postComment = (...args) => async dispatch => {
    const [url, body ] = args;
    const params = [ url, body ];

    const data = await API.postData(params, dispatch, actions);

    if (data) {
        return data;
    } else {
        console.error('Cannot postComment', url);
    }
};


export const getConsumerInformation = (...args) => async dispatch => {
    const [url, oldBody ] = args;
    let body = `ticketId=${oldBody.ticketId}`;

    const params = [ url, body , 'POST', true, undefined, 'application/x-www-form-urlencoded', true, false, true ];

    const data = await API.postData(params, dispatch, actions);

    if (data) {
        return data;
    } else {
        console.error('Cannot get Consumer Information', url);
    }
};


export const postSendMessage = (...args) => async (dispatch) => {
    const [url, oldBody ] = args;
    let body = new FormData();

    Object.keys(oldBody).forEach((key) => {
        body.append(key, oldBody[key]);
    });
    dispatch({ type: progressActionTypes.FILE_PROCESSING, payload: 0 });
    return api.post(
        url, body, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent ) => {
                let progressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total );
                if (progressPercentage < 100){
                    dispatch({ type: progressActionTypes.FILE_PROCESSING, payload: progressPercentage });
                }
            },
            onDownloadProgress: (progressEvent) => {
                let progressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total );
                if(!isFinite(progressPercentage)) {
                    dispatch({ type: progressActionTypes.FILE_PROCESSING, payload: 100 });
                    return;
                }
                if(!isNaN(progressPercentage)){
                    dispatch({ type: progressActionTypes.FILE_PROCESSING, payload: progressPercentage });
                }
            }
        }
    ).then(response => {
        setTimeout(() => {
            dispatch({ type: progressActionTypes.FILE_PROCESSED, payload: 0 });
            return  response;
        }, 1000);
        
    })
        .catch(() => {
            console.error('Cannot post Message', url);
        });
};

export const getAttachments = (...args) => async dispatch => {
    const [url] = args;
    const params = [ url];
    dispatch(isLoading(TICKET_FILE_TYPES.GET_FILE_REQUEST));

    const data = await API.getData(params, dispatch, actions);
    if (data) {
        dispatch(isLoaded(TICKET_FILE_TYPES.GET_FILE_SUCCESS, data));
        return data;
    } else {
        dispatch(isError(TICKET_FILE_TYPES.GET_FILE_ERROR, []));
    }

};

export const postAttachments = (...args) => async dispatch => {
    const [url, body ] = args;
    const params = [ url, body, 'POST', true, undefined , 'multipart/form-data', true];
    
    dispatch(isLoading(TICKET_FILE_TYPES.POST_FILE_REQUEST));

    const data = await API.postData(params, dispatch, actions);
    if (data) {
        dispatch(isLoaded(TICKET_FILE_TYPES.POST_FILE_SUCCESS, true));
        return data;
    } else {
        dispatch(isError(TICKET_FILE_TYPES.POST_FILE_ERROR, true));
    }
};

export const deleteAttachment = (...args) => async dispatch => {
    const [url, body ] = args;
    const params = [ url, body, 'POST', true, undefined , 'multipart/form-data', true, true];
    dispatch(isLoading(TICKET_FILE_TYPES.DELETE_FILE_REQUEST));
    const data = await API.postData(params, dispatch, actions);
    if (data.status === successStatusCode && data.statusText === '') {
        dispatch(isLoaded(TICKET_FILE_TYPES.DELETE_FILE_SUCCESS, true));
    } else {
        dispatch(isError(TICKET_FILE_TYPES.DELETE_FILE_ERROR, true));
    }
};
